module.exports = __webpack_public_path__ + "img/users-gear.9cece428.svg";